import AddIcon from '@mui/icons-material/Add'
import { Grid, IconButton, Paper, Stack, Typography } from '@mui/material'
import React, { useContext, useState } from 'react'
import { MeetingPageContext } from './MeetingPage'
import AgendaAccordion from './AgendaAccordion'
import AddAgendaPopup from './NewMeeting/AddAgendaPopup'
import BigModal from '../../../components/Modals/BigModal'

const Agenda = ({}) => {
  const { agendas, setAgendas, meeting, setChangesPresent } =
    useContext(MeetingPageContext)
  const [openAgendaPopup, setOpenAgendaPopup] = useState(false)

  const handleAddNewAgendaItem = () => {}

  return (
    <Grid item xs={12} lg={4} order={{ xs: 1, lg: 2 }}>
      <Stack gap={1} component={Paper} padding={1}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="title2">Agenda</Typography>
          <IconButton onClick={() => setOpenAgendaPopup(true)}>
            <AddIcon color="anPurple" />
          </IconButton>
        </Stack>
        {agendas?.map((agendaItem, key) => (
          <AgendaAccordion agendaKey={key} agendaItem={agendaItem} key={key} />
        ))}
      </Stack>
      <BigModal
        open={!!openAgendaPopup}
        onClose={() => setOpenAgendaPopup(false)}
      >
        <AddAgendaPopup
          staffOptions={meeting.invitees}
          meetingType={meeting.meetingType}
          setAgendaItems={setAgendas}
          agendaItems={agendas}
          submitAdditionalActions={() => setChangesPresent(true)}
          onClose={() => setOpenAgendaPopup(false)}
        />
      </BigModal>
    </Grid>
  )
}

export default Agenda
